const waitForElm = async (selector: any, timeout: number | null = null, location: HTMLElement = document.body) => {
  return new Promise((resolve) => {
    const element = document.querySelector(selector);
    if (element) {
      return resolve(element);
    }

    const observer = new MutationObserver(async () => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        observer.disconnect();
      } else {
        if (timeout) {
          resolve(await timeOver(timeout, observer));
        }
      }
    });

    observer.observe(location, {
      childList: true,
      subtree: true,
    });
  });
};

const timeOver = async (timeout: number, observer: MutationObserver) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      observer.disconnect();
      resolve(false);
    }, timeout);
  });
};

export default waitForElm;